/**
 * Created by rhinov4 on 15/09/2015.
 */

// This draws the grid behind the map to show scale and distances this extends a cocos 2D layer
import { Events, eventsManager } from "@rhinov/savane-js";
import { CocosConstants } from "../../../constants";

declare var cc: any;

export class Grid extends cc.Layer {
     _width = 0;
    _height = 0;
    constructor(width: number, height: number) {
        super(width, height);
        // Store width and height
        this._width = width;
        this._height = height;
        this.setName('grid');
        // Cell size will be 100px x 100px
        this.cellSize = 100;
        this.cellCount = 160;
        this._isGridVisible = false;

        // WARNING DO NOT REMOVE - THIS BUG IS RANDOM!!! 
        // Patch to prevent coco bug drawing transparent things
        var preventBugSprite = new cc.Sprite();
        preventBugSprite.setTexture(CocosConstants.resourcesBasePath + '/resources/yellowDot.png');
        preventBugSprite.setScale(0.1, 0.1);
        preventBugSprite.setPosition(0, 0);
        preventBugSprite.setName('preventCocosBug');
        this.addChild(preventBugSprite);
        // End patch to prevent cocos drawing transparent things

        // New draw node to draw lines
        this.dn = new cc.DrawNode();
        // Fill the layer vertically and horizontally
        for (var i = 0; i < this.cellCount; i++) {
            this.dn.drawSegment(new cc.p(this.cellSize * i, 0), new cc.p(this.cellSize * i, this.cellSize * this.cellCount), 1, new cc.color(236, 236, 236, 255));
            this.dn.drawSegment(new cc.p(0, this.cellSize * i), new cc.p(this.cellSize * this.cellCount, this.cellSize * i), 1, new cc.color(236, 236, 236, 255));
        }
        // Add the layer to the renderer hierarchy
        this.dn.setVisible(false);
        this.dn.setTag(0);
        this.dn.setContentSize(width, height);
        this.addChild(this.dn, 0.5);

        // View blocker
        this._locked = false;
        this._lockCenter = new cc.p(0, 0);
        this._lockSize = new cc.p(1000, 1000);
    }

    setPosition(point: {x: number, y: number}) {
        if (this._locked) {
            var contentSize = this.getContentSize();
            var centerX = this._lockCenter.x * this.getScale() + contentSize.width * 0.5;
            var minBoundX = centerX - this._lockSize.x * this.getScale() + contentSize.width * 0.5;
            var maxBoundX = this._lockCenter.x * this.getScale() + this._lockSize.x * this.getScale();

            if (this._lockSize.x * this.getScale() * 2.0 <= this.getContentSize().width) {
                point.x = centerX;
            }
            else {
                if (point.x > maxBoundX) {
                    point.x = maxBoundX;
                }
                else {
                    if (point.x < minBoundX) {
                        point.x = minBoundX;
                    }
                }
            }

            var centerY = this._lockCenter.y * this.getScale() + contentSize.height * 0.5;
            var minBoundY = centerY - this._lockSize.y * this.getScale() + contentSize.height * 0.5;
            var maxBoundY = this._lockCenter.y * this.getScale() + this._lockSize.y * this.getScale();

            if (this._lockSize.y * this.getScale() * 2.0 <= this.getContentSize().height) {
                point.y = centerY;
            }
            else {
                if (point.y > maxBoundY) {
                    point.y = maxBoundY;
                }
                else {
                    if (point.y < minBoundY) {
                        point.y = minBoundY;
                    }
                }
            }
        }
        super.setPosition(point);
    }

    // This is called by the listener listening to the event sent but the button pressed on the left floating bar to hide the grid
    changeGridVisibility(event: any) {
        // Hide/Unhide is in the user data to the message sent to the listener
        this.setGridVisibility(event.getUserData());
        this.rebuildGrid();
    }

    // Set visibility (hide/unhide) of the grid
    setGridVisibility(bool: boolean) {
        this.dn.setVisible(bool);
        this._isGridVisible = bool;
        this.rebuildGrid();
    }

    getGridVisibility(): boolean {
        return (this._isGridVisible);
    }

    // CHange the width and height of the grid
    changeWidthAndHeight(width: number, height: number) {
        this.dn.setContentSize(width, height);
        this._width = width;
        this._height = height;
    }

    /**
     * Recreate visual grid
     * @param zoom
     */
    rebuildGrid(zoom?: number) {
        if (!this.dn.isVisible())
            return;

        if (zoom !== undefined)
            this.zoom = zoom;

        var worldPos00 = this.convertToNodeSpace(new cc.p(-this.cellSize * 2 * this.getScaleX(), -this.cellSize * 2 * this.getScaleY()));
        this.dn.setPosition(new cc.p(worldPos00.x, worldPos00.y));
    }

    // Lock grid functions
    lockGrid(lockCenter: number, lockSize: number) {
        this._locked = true;
        this._lockCenter = lockCenter;
        this._lockSize = lockSize;
    }

    unlockGrid() {
        this._locked = false;
    }

    // Object creation, create the hide/unhide event listener
    onEnter() {
        super.onEnter();
        this.gridListener = eventsManager.instance.addListener(Events.HIDE_GRID_PRESSED, this.changeGridVisibility.bind(this));
    }

    // Object destruction, kill the hide/unhide listener
    onExit() {
        super.onExit();
        eventsManager.instance.removeListener(this.gridListener);
    }
}
